export default "__VITE_ASSET__7950635e__"